import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=2b317782&scoped=true"
import script from "./EditProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProfile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=2b317782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b317782",
  null
  
)

export default component.exports